import { Link } from 'react-router';

import { instructorProfilePath } from 'my-core/routes';
import { getUserFirstName } from 'my-core/user-utils';

import MuiAvatar from 'my-elements/MuiAvatar';

import Typography from '@mui/material/Typography';

import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function InstructorInfo({ className, instructor, small }) {
  return (
    <div
      className={className}
      css={({ palette, spacing }) => ({
        textAlign: 'left',
        display: 'flex',
        alignItems: 'center',
        '& .avatar': { marginRight: spacing(1.5) },
        '& .details': { minWidth: 0 },
        '& .rating': {
          color: palette.yellow.main,
        },
      })}
    >
      <MuiAvatar className="avatar" size={small ? 40 : 48} user={instructor} />
      <div className="details">
        <Typography noWrap sx={{ display: 'block' }} variant={small ? 'subtitle2' : 'subtitle1'}>
          {instructor.hide_from_public ?
            `${getUserFirstName(instructor)}  `
          : <Link to={instructorProfilePath(instructor)}>{`${getUserFirstName(instructor)}  `}</Link>}
          {instructor.instructor_stats?.feedbacks && (
            <span>
              {instructor.instructor_stats.feedbacks.average_rating.toFixed(1)}{' '}
              <FontAwesomeIcon className="rating" icon={faStar} />
            </span>
          )}
        </Typography>
        <Typography variant={small ? 'body2' : 'body1'}>{instructor.degree}</Typography>
      </div>
    </div>
  );
}
